/* eslint-disable no-restricted-globals */
import { Buffer as BufferPolyfill } from 'buffer';

export const getBuffer = () =>
  typeof Buffer !== 'undefined' ? Buffer : BufferPolyfill;
